<template>
    <div class="doc_container">
        <div>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">発行事業者</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">株式会社</span>
                <span style="font-family:Consolas">Yostar</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">東京都千代田区神田練塀町３００番住友不動産秋葉原駅前ビル１１階</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">www.mahjongsoul.com</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">ご相談窓口</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <a href="mailto:cs_jp@mahjongsoul.com" style="text-decoration:none">
                    <span style="font-family:Consolas; color:#000000">cs@mahjongsoul.com</span>
                </a>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">支払可能金額等</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">支払可能金額の上限はございません。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">販売価格</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">購入画面に記載（表示価格は消費税を含みます）。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">使用場所</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">輝石</span>
                <span style="font-family: inherit">：</span>
                <span style="font-family: inherit"></span>
                <span style="font-family: inherit">ウェブサイト</span>
                <span style="font-family: inherit">「</span>
                <span style="font-family: inherit">雀魂</span>
                <span style="font-family: inherit">」サービス内でご利用いただけます。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">キャンセル</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">デジタルアイテム等購入後のお客様のご都合によるキャンセルは、お受けできません。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">未使用残高の確認方法</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">ウェブサイ</span>
                <span style="font-family: inherit">ト</span>
                <span style="font-family: inherit">内でご覧いただけます。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">利用規約</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Consolas">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family: inherit">サービス利用規約をご覧ください。</span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt"
            >
                <span style="font-family: inherit">&#xa0;</span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({}),
    mounted() {
        document.dispatchEvent(new Event("custom-render-trigger"));
    }
};
</script>

<style lang="scss" scoped>
.doc_container {
    width: 60%;
    margin: 50px auto;

    @media screen and (max-width: 600px) {
        width: 90%;
    }
}
</style>